












import Vue from 'vue';

// Components
import translationString from '@webapp/components/translation-string.vue';

// Types
import type {
    Either,
} from '@shared/types/global';

type TextListItem = Either<{
    text: string;
    style: Record<string, unknown>;
}, string>;

export default Vue.extend({
    name: 'disclaimer',
    components: {
        translationString,
    },
    props: {
        textList: {
            type: Array,
            required: true,
            default: () => ([
                {
                    item: '',
                    style: {},
                },
            ]),
            validator: (input: TextListItem[]) => input.every((item) => Boolean(item.text && item.style) || typeof item === 'string'),
        },

        isHighlighted: {
            type: Boolean,
            default: false,
        },

        highlightColor: {
            type: String,
            default: '#ff0038',
            validator(input) {
                return input.startsWith('#');
            },
        },
    },
});
